// extracted by mini-css-extract-plugin
export default {"logContainer":"ActivityLog_logContainer__XXDbv","logs":"ActivityLog_logs__9xGjC"};